import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  overviewTabTitle: {
    id: 'frontbucket.repository.pullRequest.tabs.overviewTabTitle',
    description: 'Title of a pull request overview tab',
    defaultMessage: 'Overview',
  },
  diffTabTitle: {
    id: 'frontbucket.repository.pullRequest.tabs.diffTabTitle',
    description: 'Title of a pull request diff tab',
    defaultMessage: 'Files changed',
  },
  commitsTabTitle: {
    id: 'frontbucket.repository.pullRequest.tabs.commitsTabTitle',
    description: 'Title of a pull request commits tab',
    defaultMessage: 'Commits',
  },
  tabsListLabel: {
    id: 'frontbucket.repository.pullRequest.tabs.tabsListLabel',
    description: 'Aria label for tabs list nav element',
    defaultMessage: 'Pull request',
  },
});
